import { render, staticRenderFns } from "./MassEmailSend.vue?vue&type=template&id=77c383fe&"
import script from "./MassEmailSend.vue?vue&type=script&lang=js&"
export * from "./MassEmailSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports